
const positionMap = {
  1: 'Bác sĩ',
  2: 'Điều dưỡng',
  3: 'Kỹ thuật viên',
  4: 'Hành chính'
};


const statusMap = {
  1: 'pending',
  2: 'pending',
  3: 'interviewed',
  4: 'rejected',
  5: 'approved'
};


const findNameById = (list, id, idField, nameField) => {
  if (!list || id == null) return null;
  const arr = Array.isArray(list) ? list : (Array.isArray(list.data) ? list.data : []);
  const item = arr.find(item => Number(item[idField]) === Number(id));
  return item ? item[nameField] : null;
};


export const formatDate = (dateString) => {
  if (!dateString) return '';
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};


export const transformApplicant = (tuyenDung, lookupData = {}) => {
  const { tonGiaos = [], tinhTrangHonNhans = [], trangThaiTuyenDungs = [], xepLoaiDaoTaos = [] } = lookupData;


  const tonGiaoName = findNameById(tonGiaos, tuyenDung.idTonGiao, 'id', 'ten');

  const tinhTrangHonNhanName = findNameById(tinhTrangHonNhans, tuyenDung.idTinhTrangHonNhan, 'id', 'ten');

  const trangThaiTuyenDungName = findNameById(trangThaiTuyenDungs, tuyenDung.idTrangThaiTuyenDung, 'id', 'ten');

  return {
    id: tuyenDung.id,
    dotTuyenDungId: tuyenDung.dotTuyenDung?.idDotTuyenDung || tuyenDung.dotTuyenDung?.id || tuyenDung.idDotTuyenDung || null,
    name: tuyenDung.hoVaTen,
    fullName: tuyenDung.hoVaTen,
    email: tuyenDung.email || '',
    phone: tuyenDung.soDienThoai || '',
    position: positionMap[tuyenDung.idViTriTuyenDung] || tuyenDung.viTriChiTiet || 'Chưa xác định',
    appliedDate: formatDate(tuyenDung.ngayUngDung),
    status: statusMap[tuyenDung.idTrangThaiTuyenDung] || 'pending',
    statusName: trangThaiTuyenDungName || 'Chờ xử lý',
    idTrangThaiTuyenDung: tuyenDung.idTrangThaiTuyenDung,
    daGuiEmailLichPV: tuyenDung.daGuiEmailLichPV || false,
    daGuiEmailTrungTuyen: tuyenDung.daGuiEmailTrungTuyen || false,
    daGuiEmailRotPhongVan: tuyenDung.daGuiEmailRotPhongVan || false,
    experience: tuyenDung.kinhNghiem || 'Chưa có',
    education: tuyenDung.vanBangChuyenMon || 'Chưa cập nhật',


    avatar: tuyenDung.anhDaiDien || null,
    birthDate: formatDate(tuyenDung.namSinh),
    gender: tuyenDung.gioiTinh ? 'Nữ' : 'Nam',
    cccd: tuyenDung.soCccd || '',
    cccdDate: formatDate(tuyenDung.ngayCapCccd),
    cccdPlace: tuyenDung.noiCapCccd || '',
    permanentAddress: tuyenDung.diaChiThuongTru || '',
    currentAddress: tuyenDung.noiOHienTai || '',
    hometown: tuyenDung.queQuan || '',
    birthPlace: tuyenDung.noiSinh || '',
    ethnicity: tuyenDung.danToc || '',
    religion: tonGiaoName || 'Không',
    maritalStatus: tinhTrangHonNhanName || 'Chưa cập nhật',
    numberOfChildren: tuyenDung.soCon || 0,
    youngestChildAge: tuyenDung.tuoiConNhoNhat || 0,


    emergencyContact: {
      name: tuyenDung.hoVaTenNguoiThan || '',
      phone: tuyenDung.soDienThoaiNguoiThan || '',
      relationship: tuyenDung.quanHeNguoiThan || ''
    },

    healthStatus: tuyenDung.tinhTrangSucKhoe || 'Chưa cập nhật',
    height: tuyenDung.chieuCao ? parseInt(tuyenDung.chieuCao) : null,
    weight: tuyenDung.canNang || null,
    medicalHistory: tuyenDung.tienSuBenh || 'Không có',


    licenseNumber: tuyenDung.soGphn || '',
    licenseIssueDate: formatDate(tuyenDung.ngayCapGphn),
    licensePlace: tuyenDung.noiCapGphn || '',
    licenseDegree: tuyenDung.vanBangChuyenMon || '',
    licenseScope: tuyenDung.phamViHoatDong || '',


    skills: tuyenDung.kyNang || '',
    softSkills: tuyenDung.soThich || '',
    careerExpectation: tuyenDung.nguyenVong || '',

    degrees: tuyenDung.bangCaps?.map(bc => {
      const xepLoaiName = findNameById(xepLoaiDaoTaos, bc.idXepLoaiDaoTao, 'id', 'ten');
      return {
        name: bc.tenBangCap,
        school: bc.donViDaoTao,
        year: formatDate(bc.namTotNghiep),
        grade: xepLoaiName || (bc.idXepLoaiDaoTao ? `Loại ${bc.idXepLoaiDaoTao}` : 'Chưa cập nhật'),
        image: bc.hinhAnh
      };
    }) || [],

    certificates: tuyenDung.chungChis?.map(cc => ({
      name: cc.tenChungChi,
      institution: cc.donViDaoTao,
      isCme: cc.cme,
      issueDate: formatDate(cc.ngayCap),
      image: cc.hinhAnh
    })) || []
  };
};

export const transformApplicants = (tuyenDungs, lookupData = {}) => {
  const arr = Array.isArray(tuyenDungs) ? tuyenDungs : (Array.isArray(tuyenDungs?.data) ? tuyenDungs.data : []);
  return arr.map(td => transformApplicant(td, lookupData));
};

export const calculateStats = (applicants) => {
  return {
    total: applicants.length,
    pending: applicants.filter(a => a.status === 'pending').length,
    interviewed: applicants.filter(a => a.status === 'interviewed').length,
    approved: applicants.filter(a => a.idTrangThaiTuyenDung === 3).length,
    rejected: applicants.filter(a => a.idTrangThaiTuyenDung === 4).length
  };
};

export const createCampaignFromApplicants = (applicants, campaignId) => {
  const stats = calculateStats(applicants);
  return {
    id: campaignId || 1,
    title: 'Đợt tuyển dụng hiện tại',
    status: 'active',
    startDate: '01/01/2024',
    endDate: '31/12/2024',
    positions: new Set(applicants.map(a => a.position)).size,
    applications: stats.total,
    interviewed: stats.interviewed,
    hired: stats.approved,
    description: 'Tuyển dụng nhân sự cho các vị trí y tế và hành chính'
  };
};


export const transformDotTuyenDung = (dot, applicantsByDot = []) => {
  const stats = calculateStats(applicantsByDot);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const endDate = dot.ketThuc ? new Date(dot.ketThuc) : null;
  const isExpired = endDate && endDate < today;
  const isLocked = dot.isKhoa !== 0 && dot.isKhoa !== false;
  const isActive = !isExpired && !isLocked;
  const dotId = dot.idDotTuyenDung ?? dot.id;

  return {
    id: dotId,
    title: dot.tenDotTuyenDung,
    status: isActive ? 'active' : 'completed',
    startDate: formatDate(dot.batDau),
    endDate: formatDate(dot.ketThuc),
    rawEndDate: dot.ketThuc || null,
    positions: new Set(applicantsByDot.map(a => a.position)).size || 0,
    applications: stats.total,
    interviewed: stats.interviewed,
    hired: stats.approved,
    description: `Đợt tuyển dụng: ${dot.tenDotTuyenDung}`
  };
};

export const transformDotTuyenDungs = (dots, allApplicants = []) => {
  const arr = Array.isArray(dots) ? dots : (Array.isArray(dots?.data) ? dots.data : []);
  return arr.map(dot => {

    const dotId = Number(dot.idDotTuyenDung ?? dot.id);
    const applicantsInDot = allApplicants.filter(a => {
      const applicantDotId = Number(a.dotTuyenDungId ?? a.idDotTuyenDung);
      return Number.isFinite(dotId) && Number.isFinite(applicantDotId) && applicantDotId === dotId;
    });
    return transformDotTuyenDung(dot, applicantsInDot);
  });
};
